export enum MainWorkflowNode {
  Case = 1,
  Files,
  Order,
  Reprint
}
